import React from "react";
import assets from "../../../../shared/constants/assetVariables";

function FeatureTwo() {
  return (
    <section className="scm-feature-section">
      <div className="scm-feature-container">
        <div className="scm-feature-wrapper">
          <div className="scm-feature-image-wrapper">
            <div className="scm-feature-image">
              <img src={assets.images.scmImage2} alt="updapt" />
            </div>
          </div>
          <div className="scm-feature-content-wrapper">
            <div className="scm-feature-content">
              <h2 className="scm-feature-title">
                Effortlessly measure supplier risks
              </h2>
              <p className="scm-feature-description">
                Calculate the risk level of your suppliers by evaluating their
                response to various ESG factors and determine accurate risk
                scores for each supplier.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FeatureTwo;
